export default {
  SET_COURSES_LATEST (state, courses) {
    state.latestCourses = courses;
  },

  SET_POPULAR_COURSES (state, courses) {
    state.popularCourses = courses;
  },

  SET_LATEST_COURSES_FETCH_STATUS (state, status) {
    state.latestCoursesFetchStatus = status
  },

  SET_POPULAR_COURSES_FETCH_STATUS (state, status) {
    state.popularCoursesFetchStatus = status
  }
}
